module.exports = __webpack_public_path__ + "img/09_Steuerung-Tabelle.3808ce7d.svg";